import {WidgetInstance} from "friendly-challenge";
import getParents from "./getParents";

export default class WbxFriendlyCaptcha {
    constructor() {
        this.endpointIsEurope = true;
        window.addEventListener('load', () => {
            this.init();
        });
    }

    init() {
        let elements = document.querySelectorAll('.frc-captcha');
        if (elements.length) {
            elements.forEach((v, k) => {
                let fcSiteKey = v.dataset.sitekey;
                if (!fcSiteKey) {
                    console.log("FriendlyCaptcha: Sitekey ist missing!");
                    return;
                }

                let options = {
                    puzzleEndpoint: (this.endpointIsEurope) ? "https://eu-api.friendlycaptcha.eu/api/v1/puzzle" : "https://api.friendlycaptcha.com/api/v1/puzzle",
                    doneCallback: this.doneCallback,
                    sitekey: fcSiteKey,
                    startMode: "none"
                }

                let widget = new WidgetInstance(v, options);

                let form = getParents(v, "form")[0];
                if (form) {
                    form.addEventListener("submit", (e) => {
                        e.preventDefault();
                        if (form.checkValidity()) {
                            widget.start();
                        }
                    });
                }
            });
        }
    }

    doneCallback(solution) {
        let input = document.querySelector(`input[value="${solution}"]`);
        if (input) {
            let form = getParents(input, "form")[0];
            if (form) {
                form.submit();
            }
        }
    }
}
